import React, { useState } from "react";
import Calendar from "react-calendar";
import "../components/css/Calendar.css"; // Import default styles
import Header from "../components/Header";
import Banner from "../components/Banner";

const CalendarComponent = () => {
  const [date, setDate] = useState(new Date());

  const handleDateChange = (newDate) => {
    setDate(newDate);
    console.log("Selected Date:", newDate); // You can handle the date as needed
  };

  return (
    <>
    <Header/>
    <Banner/>

    <div className="calendar-container">

      <Calendar onChange={handleDateChange} value={date} />
    </div>
    
    </>
  );
};

export default CalendarComponent;
